import AddressChangeIcon from '@acorn-portal/shared/src/assets/shared/icons/base/house.svg?react';
import { Box, Typography } from '@mui/material';

import { Address } from '@acorn-portal/shared/src/services/api';
import { FC } from 'react';
import { shouldShowOvernightAddress } from '../../utils/should-show-overnight-address';

interface IAddressDisplay {
	address?: Address;
	overnightAddress?: Address;
}

const formatAddress = (address: Address): string => {
	const parts = [address.line1, address.line2, address.city, address.county, address.country, address.postcode].filter(
		Boolean,
	);

	return parts.join(', ');
};

const AddressDisplay: FC<IAddressDisplay> = ({ address, overnightAddress }) => {
	if (!address) return null;
	const showOvernightAddress = shouldShowOvernightAddress(overnightAddress, address);

	return (
		<Box>
			<Box sx={{ display: 'flex' }}>
				<Box sx={{ width: '65px', marginRight: '3em' }}>
					<AddressChangeIcon />
				</Box>
				<Box sx={{ flex: 1, pb: 2 }}>
					<Typography>{formatAddress(address)}</Typography>

					{overnightAddress && showOvernightAddress && (
						<Typography>
							<strong>Overnight: </strong>
							{formatAddress(overnightAddress)}
						</Typography>
					)}
				</Box>
			</Box>
		</Box>
	);
};

export default AddressDisplay;
